import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import HtmlDiff from "htmldiff-js";
import { RichTextView } from "../RichTextView/RichTextView";
import styles from "./RichTextDiffView.scss";

const msgKey = "richTextDiffView";

export const RichTextDiffView = ({ oldHtml, newHtml }) => {
    const diffHtml = useMemo(() => {
        const old = oldHtml ?? "";
        const newVal = newHtml ?? "";
        const HtmlDiffClass = HtmlDiff?.default ?? HtmlDiff;
        return new HtmlDiffClass(old, newVal).build();
    }, [oldHtml, newHtml]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.legend}>
                <span className={styles.legendItemRemoved}>
                    <FormattedMessage id={`${msgKey}.removedInLatest`} />
                </span>
                <span className={styles.legendItemAdded}>
                    <FormattedMessage id={`${msgKey}.addedInLatest`} />
                </span>
            </div>
            <RichTextView html={diffHtml} />
        </div>
    );
};
